import { Anchor, Mark, Text, TextProps } from "@mantine/core"

interface LinkifiedTextProps extends Omit<TextProps, "children"> {
  content: string
  highlight?: string
}

export function LinkifiedText({
  content,
  highlight,
  ...props
}: LinkifiedTextProps) {
  const urlRegex = /(https?:\/\/[^\s]+|www\.[^\s]+)/g
  const parts = content?.split(urlRegex)
  const search = highlight?.trim()
  const highlightRegex = search
    ? new RegExp(`\\b(${search.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")})`, "gi")
    : undefined

  const renderHighlighted = (value: string, key: string) => {
    if (!highlightRegex || !search) return value
    return value
      .split(highlightRegex)
      .map((part, index) =>
        part.toLocaleLowerCase() === search.toLocaleLowerCase() ? (
          <Mark key={`${key}-${index}`}>{part}</Mark>
        ) : (
          <React.Fragment key={`${key}-${index}`}>{part}</React.Fragment>
        )
      )
  }

  return (
    <Text span {...props}>
      {parts?.map((part, i) => {
        if (/^(https?:\/\/[^\s]+|www\.[^\s]+)$/.test(part)) {
          const href = part.startsWith("http") ? part : `https://${part}`
          return (
            <Anchor
              c={props.c}
              key={i}
              href={href}
              target="_blank"
              rel="noopener noreferrer"
            >
              {renderHighlighted(part, `url-${i}`)}
            </Anchor>
          )
        }
        return (
          <Text span key={i}>
            {renderHighlighted(part, `text-${i}`)}
          </Text>
        )
      })}
    </Text>
  )
}
